import React from 'react';
import { HeroDesktop } from './hero/HeroDesktop';
import { HeroMobile } from './hero/HeroMobile';
export function HomeHero() {
  return <section id="home-hero" aria-label="MarineForceLED" className="relative bg-deep" data-id="element-270" data-mp="2i6jyl2rc82q6">
      <HeroDesktop data-id="element-271" data-mp="246r8n9nmxqj9" />
      <HeroMobile data-id="element-272" data-mp="247k9xv3trnu0" />
    </section>;
}